import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.previousFocus = null
  }

  open() {
    this.previousFocus = document.activeElement
    this.dialogTarget.showModal()
    this.dialogTarget.setAttribute("aria-modal", "true")
    
    // Focus first focusable element
    requestAnimationFrame(() => {
      const focusable = this.dialogTarget.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 0) {
        focusable[0].focus()
      }
    })
  }

  close() {
    this.dialogTarget.close()
    this.dialogTarget.removeAttribute("aria-modal")
    
    // Restore focus to previously focused element
    if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
      this.previousFocus.focus()
    }
  }

  // Close on Escape key
  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  // Close when clicking backdrop
  clickOutside(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
